import { api } from "@/services/api"
import { queryClient } from "@/queryClient"
import type { User } from "./sharedTypes"

export type EditUserRequest = {
  firstName: string
  lastName: string
  email: string
  phone: string | null
  isActive: boolean
}

export const editUser = async (
  userId: string,
  params: EditUserRequest
) => {
  await api.put<User>(`/users/${userId}/`, { body: params })

  queryClient.invalidateQueries([USERS_QUERY_KEY])
}
